import type { Maybe } from '@passionware/monads';
import {
  workspaceScopingQueryUtils,
  type WorkspaceScoping
} from 'v5/api/_common/query/workspace-scoping';
import type { Nullable } from 'v5/platform/typescript';

type Copy = Maybe<{ enterprise_workspace_id?: Nullable<number> }>;

/**
 * Whose resources a production's picker searches: its own workspace (the organization for a
 * production of none), from the first copy of it that says: its record, then the v1 store's
 * (the calendar's, the drawer's). `unknown` when none says: never the organization by default.
 */
export function productionScopeOf(
  record: Copy,
  storeCopy: Copy
): { type: 'known'; scope: WorkspaceScoping } | { type: 'unknown' } {
  const workspaceId =
    record?.enterprise_workspace_id !== undefined
      ? record.enterprise_workspace_id
      : storeCopy?.enterprise_workspace_id;
  if (workspaceId === undefined) return { type: 'unknown' };
  return {
    type: 'known',
    scope:
      workspaceId === null
        ? workspaceScopingQueryUtils.ofGlobal()
        : workspaceScopingQueryUtils.ofWorkspace(workspaceId)
  };
}
